import type { FC } from 'react'
import React from 'react'
import { JOURNAL_TAG_ATTRIBUTES } from '@/constants/journal'
import { messages } from '../messages'
import type { IPublicationComponentProps } from '../types'

const { subscribe } = JOURNAL_TAG_ATTRIBUTES

export const PublicationSubscribe: FC<IPublicationComponentProps> = props => {
  const { attribs } = props

  return (
    <div className={`focusBlock publicationText__subscribe subscribe`}>
      <div className="subscribe__textWrapper">
        <div className="subscribe__textHeading">
          <p className="h4">{attribs[subscribe.header]}</p>
          <p>{attribs[subscribe.message]}</p>
        </div>
        <a href={attribs[subscribe.url]} className={`button button_green subscribe__button`}>
          {messages.subscribeBtnText}
        </a>
      </div>
      <div className="subscribe__logo" />
    </div>
  )
}
